var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-accordion',[_c('header',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Behaviour and communication")]),_c('section',{attrs:{"slot":"content"},slot:"content"},[_c('behaviour-section'),_c('communication-section')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }